<template>
    <div class="accountLogin">
        <div class="bg">
            <div class="codeBg">
                <div class="txt">
                    <img src="~assets/img/logo.png" alt="">
                    <div>国际高等教育平台语言学习平台</div>
                </div>
                <div class="codeBg2">
                    <el-form :model="ruleForm" ref="ruleForm" label-width="70px" class="demo-ruleForm">
                        <el-form-item label="账号" prop="account">
                            <el-input v-model="ruleForm.account" placeholder="请输入账号"></el-input>
                        </el-form-item>
                        <el-form-item label="密码" prop="pass">
                            <el-input type="password" v-model="ruleForm.pass" show-password autocomplete="off" placeholder="请输入密码"></el-input>
                        </el-form-item>
                        <div>
                            <el-button type="primary">登录</el-button>
                        </div>
                    </el-form>
                </div> 
               
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                ruleForm: {
                    pass: '',
                    account: '',
                },
            }
        },
    }
</script>

<style scoped lang="scss">
    .bg{
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: url(~assets/img/qr_bg.png) no-repeat center;
        background-size: 100%;
    }
    .codeBg{
        height: 4.5rem;
        width:4.8rem;
        position: absolute;
        top:0;left:0;right:0;bottom: 0;
        margin:auto;
        z-index:10;
        text-align: center;
    }
    .codeBg2{
        width:4.8rem;
        padding:0.7rem;
        background:#fff;
        border-radius: 0.1rem;
    }
    .txt{
        font-family:Alibaba PuHuiTi;
        text-shadow:0px 2px 3px #000;
        color:#fff;
        font-size: 30px;
        font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        img{
            margin-right: 15px;
        }
    }
    .el-button{
        padding:12px 72px;
        margin-top:20px;
    }
    .el-button--primary {
        background-color: #409EFF;
        border-color: #409EFF;
    }
    
</style>